/* eslint-disable @typescript-eslint/naming-convention */
import { useRef, useState } from 'react';

type CallableValue<T> = T | (() => T);

type GetStateAction<T> = () => T;

export default function useGetState<T>(
  initialState: CallableValue<T>,
): [T, React.Dispatch<React.SetStateAction<T>>, GetStateAction<T>] {
  const _initialState = typeof initialState === 'function' ? (initialState as Function)() : initialState;

  const ref = useRef<T>(_initialState);

  const [state, setState] = useState(_initialState);

  const getState = () => {
    return ref.current;
  };

  const setStatePlus = (payload: T | ((prevState: T) => T)) => {
    const _payload = typeof payload === 'function' ? (payload as Function)(state) : payload;
    ref.current = _payload;
    setState(_payload);
  };

  return [state, setStatePlus, getState];
}
